export const PATH_VARIABLES = {
  caseId: ':caseId',
  claimId: ':claimId',
};

const PUBLIC = {
  // NO LAYOUT
  pageNotFound: '/404',
  login: '/login',
  forgotPassword: '/forgot-password',
  passwordReset: '/password-reset',
  auth: '/__auth',
  accountActivation: '/account-activation',
  terms: '/terms',
  privacyPolicy: '/privacy',
  invalidLinkInvitation: '/invalid',
};

const PRIVATE_BASE = {
  // TOP NAVBAR WITH CONTROLS ONLY
  root: '/',
  dashboard: '/dashboard',
  permissions: '/permissions/:tab?',
  security: '/security',
  scheduledReports: '/scheduled-reports',
  caseSettings: '/case-settings',
  caseSetup: '/case-setup',
  claimscoreSettings: '/claimscore-settings',
  claimScoreSettings: '/case-settings/basic-information',
  newCaseCreation: '/case-creation',
  uploadClaimsFile: '/upload-claims-file',
  claimFiles: '/files',
  developerTools: '/developer-tools/:tab?',
};

const CASE_SETTINGS_NAVIGATION = {
  basicInformation: '/basic-information',
  eligibilityRequirements: '/eligibility-requirements',
  payoutCalculationMethod: '/payout-calculation',
  caseTeam: '/case-team',
};

export const PATHS = {
  PUBLIC,
  PRIVATE_BASE,
  CASE_SETTINGS_NAVIGATION,
};
